import {
  DELIVERY_TYPE,
  DINEIN_TYPE,
  PICKUP_TYPE,
  SCHEDULED,
} from '../../webStorage/keys/sessionKeys';
import { ASAP, CALENDAR, DELIVERY, DINING, RESET_STORE, TAKEAWAY } from './orderTypeTypes';

export const setOrderType = (type, payload) => {
  switch (type) {
    case DINEIN_TYPE: {
      return {
        type: DINING,
      };
    }
    case DELIVERY_TYPE: {
      return {
        type: DELIVERY,
      };
    }
    case PICKUP_TYPE: {
      return {
        type: TAKEAWAY,
      };
    }
    case ASAP: {
      return {
        type: ASAP,
        payload,
      };
    }
    case SCHEDULED: {
      return {
        type: CALENDAR,
        payload,
      };
    }
    case RESET_STORE:
      return { type: RESET_STORE };

    default: {
      // console.log('order type cananot be changed');
      return {};
    }
  }
};
